import { datadogRum } from "@datadog/browser-rum";

export type ScrollGlobalWrite = { prop: string; valueType: string; stack: string };

declare global {
  interface Window {
    __scrollGlobalWrites?: ScrollGlobalWrite[];
    __onScrollGlobalWrite?: (entry: ScrollGlobalWrite) => void;
  }
}

// Reports overwrites blocked by public/scroll-global-guard.js (PROA-2811), including any recorded before
// Datadog started. The error carries the offender's stack so Error Tracking groups by that script.
export const reportScrollGlobalWrites = (win: Window = window) => {
  const report = (entry: ScrollGlobalWrite) => {
    const error = new Error(`Blocked overwrite of window.${entry.prop}`);
    error.stack = entry.stack;
    datadogRum.addError(error, { scroll_global_write: entry });
  };
  (win.__scrollGlobalWrites ?? []).forEach(report);
  win.__onScrollGlobalWrite = report;
};
